import { ANALYTICS_ROUTE, LISTINGS_ROUTE, ORGS_ROUTE, SOLUTIONS_ROUTE, TRIAL_TEMPLATES_ROUTE } from '~/modules/stores/routerStore';
import { FeatureFlags } from '../services/featureFlagsService';
import { i18nStore } from '../stores/i18nStore';
export function getMenuItems() {
  const {
    i18nStaticCache
  } = i18nStore.getState();
  const labels = i18nStaticCache.globalHeader;
  const technologySubmenu = [];

  // SF Labs should not have access to Trial Templates page
  if (!FeatureFlags.HIDE_TRIAL_TEMPLATES_TAB) {
    technologySubmenu.push({
      name: labels.trialTemplatesLabel,
      href: `/${TRIAL_TEMPLATES_ROUTE}`,
      styleclass: 'sub-nav-item',
      active: false
    });
  }
  technologySubmenu.push({
    name: labels.orgsLabel,
    href: `/${ORGS_ROUTE}`,
    styleclass: 'sub-nav-item',
    active: false
  });
  const commonItems = [{
    name: labels.listingsLabel,
    href: `/${LISTINGS_ROUTE}`,
    styleclass: 'nav-item',
    active: false,
    nav: []
  }, {
    name: labels.technologiesLabel,
    href: `/${SOLUTIONS_ROUTE}`,
    styleclass: 'nav-item',
    active: false,
    nav: [{
      name: labels.solutionsLabel,
      href: `/${SOLUTIONS_ROUTE}`,
      styleclass: 'sub-nav-item',
      active: false
    }, ...technologySubmenu]
  }];
  const navItems = {
    name: labels.homeLabel,
    href: '/',
    styleclass: 'nav-item',
    active: false,
    nav: [{
      name: labels.overviewLabel,
      href: `/`,
      styleclass: 'sub-nav-item',
      active: false
    }]
  };
  if (FeatureFlags.SHOW_ANALYTICS_EXPORT_PAGE) {
    navItems.nav.push({
      name: labels.analyticsLabel,
      href: `/${ANALYTICS_ROUTE}`,
      styleclass: 'sub-nav-item',
      active: false
    });
  }
  return [navItems, ...commonItems];
}